import { getApiUrlString, setUrlMap } from '../modules/get_apiUrlString'
import { modelingTimeString } from '../modules/get_convertStr'

import roundCommonProcess from './process/roundCommonProcess'

console.log('api_thread_round.js')
const urlMap = {};

onmessage = async function(ev) {
  Object.assign(urlMap, ev.data);
  setUrlMap(urlMap);
  console.log('urlMap', urlMap);

  const postData = await roundCommonProcess(ev.data);
  console.log(postData);
  if (postData.type == 'error') {
    postData.cb();
    return;
  }

  if (!postData.page.hasTtResult) {
    postMessage({
      type: 'error',
      isFinishedTimetrial: postData.page.hasTtResult
    })
    return;
  }

  // タイムトライアル用データの取得
  const timetrialQueryString = `?promoter_year=${postData.promote.year}&season=${postData.promote.season}&round_code=${postData.page.roundCode}`
  const timetrialResultPromise = await fetch(getApiUrlString('timetrial', timetrialQueryString))
    .then(res => res.json())
    .then(res => res.data);
  console.log('timetrialResultPromise', timetrialResultPromise.tt_result_list)

  timetrialResultPromise.tt_result_list = timetrialResultPromise.tt_result_list.map(order => {
    // console.log(order);
    const player_name = order.last_name_jp && order.first_name_jp
      ? `${order.last_name_jp} ${order.first_name_jp}`
      : 'ー';
    return {
      rank: order.rank,
      total_time: modelingTimeString(order.total_time),
      player_id: order.pf_250_regist_id,
      player_name,
      player_country_code: order.country_code,
      gear_rate: (() => {
        if (order.gear) {
          return `${order.gear * 1000}`.slice(0, 1) + '.' + `${order.gear * 1000}`.slice(1, 3);
        }
        return null;
      })()
    }
  })
  postData.timetrial = timetrialResultPromise;

  postData.page.isTimetrialDiscontinuation = timetrialResultPromise.hold_status == 2;

  // メインスレッドへのデータ返却
  postMessage(postData);
}
